import { useCallback, useEffect, useState } from 'react';
import * as templatesApi from '../services/api/templatesApi';

export function useTemplates() {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    setLoading(true);
    const data = await templatesApi.getTemplates();
    setTemplates(data);
    setLoading(false);
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  const addTemplate = useCallback(async (templateData) => {
    const created = await templatesApi.createTemplate(templateData);
    setTemplates((prev) => [...prev, created]);
    return created;
  }, []);

  const editTemplate = useCallback(async (id, updates) => {
    const updated = await templatesApi.updateTemplate(id, updates);
    setTemplates((prev) => prev.map((t) => (t.id === id ? updated : t)));
    return updated;
  }, []);

  const removeTemplate = useCallback(async (id) => {
    await templatesApi.deleteTemplate(id);
    setTemplates((prev) => prev.filter((t) => t.id !== id));
  }, []);

  return { templates, loading, reload, addTemplate, editTemplate, removeTemplate };
}
